import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsStars } from "react-icons/bs";
import { VscDebugRestart } from "react-icons/vsc";
import useHomeFilters from "../../../store/hooks/useHomeFilters";
import { getJobs } from "../../../store/thunks/jobsThunk";
import { colors } from "../../../utils/Colors";
import AppleAutoComplete from "../../common/AppleAutoComplete";
import { Styles } from "./locationFilter";
import AISearchModal from "../AISearchModal";

const LocationFilter = ({ onAiFilters, onClearAiFilters }) => {
  const {
    filters: { sectionFilter },
    handleUpdatingFilters,
  } = useHomeFilters();
  const dispatch = useDispatch();
  const [aiModalOpen, setAiModalOpen] = useState(false);

  // Show clear button only when AI filters are active
  const isAiActive = useSelector((state) => state.aiSearch?.isActive === true);

  useEffect(() => {
    dispatch(getJobs());
  }, [dispatch]);

  const onSelectPlaces = (result) => {
    handleUpdatingFilters({
      applePlaceFilter: result.value,
    });
  };
  const handleCheckboxChange = (type) => {
    let filterValues = sectionFilter === "all" ? ["gigs", "projects", "jobs"] : sectionFilter.split(",");
    if (filterValues.includes(type)) {
      filterValues = filterValues.filter((item) => item !== type);
    } else {
      filterValues.push(type);
    }
    if (filterValues.length === 0) {
      handleUpdatingFilters({ sectionFilter: "all" });
    } else {
      handleUpdatingFilters({ sectionFilter: filterValues.join(",") });
    }
    if (filterValues.length === 3) {
      handleUpdatingFilters({ sectionFilter: "all" });
    }
  };

  return (
    <Styles colors={colors}>
      <AISearchModal
        isOpen={aiModalOpen}
        toggle={() => setAiModalOpen(false)}
        onFiltersReady={(filters) => {
          setAiModalOpen(false);
          // alert(JSON.stringify(filters, null, 2));
          if (onAiFilters) onAiFilters(filters);
        }}
      />
      <div className="location-filter">
        <div className="location-filter-wrapper">
          <div className="search-section">
            <div className="search-location">
              <AppleAutoComplete onSelect={onSelectPlaces} />
            </div>
            {/* AI Search — looks like an input field, opens modal on click */}
            <div className="search-location" >
            <div
              className="ai-search-btn"
              role="button"
              tabIndex={0}
              onClick={() => setAiModalOpen(true)}
              onKeyDown={(e) => e.key === "Enter" && setAiModalOpen(true)}
              title="AI Smart Search"
            >
              <BsStars size={14} />
              <span className="ai-search-placeholder">AI smart search…</span>
              <span className="ai-search-badge">AI</span>
            </div>
</div>
            {/* Clear AI Filters — only visible when AI filters are active */}
            {isAiActive && (
              <button
                className="ai-clear-btn"
                onClick={onClearAiFilters}
                title="Clear AI Filters"
              >
                <VscDebugRestart size={15} />
                Clear Filters
              </button>
            )}
          </div>

          <div className="switches-section">
            <div className="locations-wrapper">
              <label style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>Service Providers</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault1"
                  style={{ cursor: "pointer" }}
                  onChange={() => handleCheckboxChange("gigs")}
                  checked={sectionFilter.includes("gigs") || sectionFilter === "all"}
                />
              </div>
            </div>
            <div className="locations-wrapper">
              <label style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>Clients</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault2"
                  style={{ cursor: "pointer" }}
                  onChange={() => handleCheckboxChange("projects")}
                  checked={sectionFilter.includes("projects") || sectionFilter === "all"}
                />
              </div>
            </div>
            <div className="locations-wrapper">
              <label style={{ fontFamily: '"MS_Bold", "Arial Black", sans-serif' }}>Employers</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault3"
                  style={{ cursor: "pointer" }}
                  onChange={() => handleCheckboxChange("jobs")}
                  checked={sectionFilter.includes("jobs") || sectionFilter === "all"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default LocationFilter;
